import axios from "axios";

export const http = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

export const errorText = (e) => (typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Something went wrong. Please try again.");
